import AxiosIndicatorRunTimeLoader from "../../../component/AxiosIndicatorRunTimeLoader";
import React from "react";

class CompareProduct {
    static register = {
        CP_ADD_TO_CART: {slug: 'CP_ADD_TO_CART', render: <AxiosIndicatorRunTimeLoader/>},
        CP_CLICK_TO_QUOTE:{slug:'CP_CLICK_TO_QUOTE'},
        CP_VIEW_CART:{slug:'CP_VIEW_CART'},
        CPG_CLICK_TO_QUOTE:{slug:'CPG_CLICK_TO_QUOTE',render:<></>}
    };
    static register_external = {
        CP_CLICK_TO_QUOTE: {slug: 'CP_CLICK_TO_QUOTE', render: <></>},
    }
    static register_guest = {
        CPG_CLICK_TO_QUOTE:{slug:'CPG_CLICK_TO_QUOTE',render:<></>},
    }
}

export default CompareProduct;